<div class="layout-breadcrumb-container">
  <div class="layout-breadcrumb-left-items">
    <a
      href="#"
      class="menu-button"
      (click)="main.onMenuButtonClick($event)"
      *ngIf="main.isStatic() && !main.isMobile()"
    >
      <i class="fa fa-bars fa-fw"></i>
    </a>

    <p-breadcrumb
      [model]="items"
      styleClass="layout-breadcrumb py-2"
    ></p-breadcrumb>
  </div>
  <div class="layout-breadcrumb-right-items">
    <!-- <mx-dropdown
      [options]="appSubscriptions"
      [(ngModel)]="selectedAppSubscription"
      (mxOnChange)="changeAppSubscription()"
      [showClear]="false"
      [filter]="false"
      [useSelectedItemTemplate]="true"
      [useItemTemplate]="true"
      [style]="{ width: '300px', 'margin-right': '30px' }"
    >
      <ng-template #selectedItemTemplateRef let-sub>
        {{ sub.label }}
      </ng-template>
      <ng-template #itemTemplateRef let-sub>
        {{ sub.label }}
      </ng-template>
    </mx-dropdown> -->
    <!-- <a tabindex="0" class="search-icon" (click)="main.searchActive = true; main.searchClick = true;">
            <i class="fa fa-search fa-fw"></i>
        </a> -->

    <!-- <div class="search-wrapper" [ngClass]="{'active-search-wrapper': main.searchActive}">
            <span class="p-input-icon-left">
                <i class="fa fa-search fa-fw"></i>
                <input type="text" pInputText placeholder="Search..." [(ngModel)]="search" (click)="main.searchClick=true"/>
            </span>
        </div> -->

    <!-- <button pButton pRipple type="button" label="Today" icon="fa fa-bookmark fa-fw" *ngIf="!main.isMobile()"
                class="layout-rightmenu-button" (click)="main.onRightMenuButtonClick()"></button>
        <button pButton pRipple type="button" icon="fa fa-bookmark fa-fw" *ngIf="main.isMobile()"
                class="layout-rightmenu-button" (click)="main.onRightMenuButtonClick()"></button> -->
  </div>
</div>
